"use client";

import dynamic from "next/dynamic";

/**
 * Lazy client wrappers for the JLT blocks.
 *
 * next/dynamic only code-splits when the dynamic() call itself lives inside a
 * client boundary. Calling it from the server BlockRenderer maps meant every
 * client block was pulled into each route's client bundle — a blog post shipped
 * InfoBox, Rating, Table, TestimonialSlider and the rest despite never
 * rendering them. Declaring them here gives each block its own chunk, fetched
 * only when a post actually contains that block.
 *
 * Server-component blocks stay in the map files: they must not be imported
 * across a client boundary.
 */

export const CounterUp = dynamic(() => import("@litonarefin/components/MbBlocks/CounterUp"));
export const BgBanner = dynamic(() => import("@litonarefin/components/JltBlocks/BgBanner"));
export const Blockquote = dynamic(() => import("@litonarefin/components/JltBlocks/Blockquote"));
export const Rating = dynamic(() => import("@litonarefin/components/JltBlocks/Rating"));
export const Container = dynamic(() => import("@litonarefin/components/JltBlocks/Container"));
export const Pricing = dynamic(() => import("@litonarefin/components/JltBlocks/Pricing"));
export const Switcher = dynamic(() => import("@litonarefin/components/JltBlocks/Switcher"));
export const IconText = dynamic(() => import("@litonarefin/components/JltBlocks/IconText"));
export const Faq = dynamic(() => import("@litonarefin/components/JltBlocks/Faq"));
export const FreemiusButton = dynamic(() => import("@litonarefin/components/JltBlocks/FreemiusButton"));
export const SubscribeButton = dynamic(() => import("@litonarefin/components/JltBlocks/SubscribeButton"));
export const InfoBox = dynamic(() => import("@litonarefin/components/JltBlocks/InfoBox"));
export const FilterTab = dynamic(() => import("@litonarefin/components/JltBlocks/FilterTab"));
export const JltButtons = dynamic(() => import("@litonarefin/components/JltBlocks/Buttons"));
export const JltButton = dynamic(() => import("@litonarefin/components/JltBlocks/Button"));
export const NewPricing = dynamic(() => import("@litonarefin/components/JltBlocks/NewPricing/NewPricing"));
export const LiveDemoForm = dynamic(() => import("@litonarefin/components/JltBlocks/LiveDemoForm"));
export const Listing = dynamic(() => import("@litonarefin/components/JltBlocks/Listing"));
export const BundlePricing = dynamic(() => import("@litonarefin/components/JltBlocks/BundlePricing"));
export const WooCommerceButton = dynamic(() => import("@litonarefin/components/JltBlocks/WooCommerceButton"));
export const JltAppsumoCodeRedemption = dynamic(() => import("@litonarefin/components/JltBlocks/JltAppsumoCodeRedemption"));
export const JltFreemiusAffiliateForm = dynamic(() => import("@litonarefin/components/JltBlocks/JltFreemiusAffiliateForm"));
export const FluentFormClient = dynamic(() => import("@litonarefin/components/JltBlocks/FluentForm/index-client"));
export const JltContainerScroll = dynamic(() => import("@litonarefin/components/JltBlocks/JltContainerScroll"));
